import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';

import {mergeDeepRight} from 'ramda';

import {GetArticleUpdateJobResponse} from '../types';

const getArticleUpdateJobMock = (
  configuration: Partial<GetArticleUpdateJobResponse> = {}
): GetArticleUpdateJobResponse =>
  mergeDeepRight(
    {
      articleUpdateJobId: '06dcd2ab-5ce6-46b0-bf5b-0a57b82ec423',
      branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
      state: 'NEW' as const,
      source: 'USER' as const,
      note: null,
      supplierId: 'a024ebfe-b790-47b2-ac85-da86ac458869',
      publishedAt: null,
      isApproved: false,
      approvedAt: null,
      approvedBy: null,
      plannedExecutionAt: null,
      plannedBy: null,
      isPlanned: false,
      executedAt: null,
      completedAt: null,
      canceledAt: null,
      canceledBy: null,
      articleScopeLimitToUpdateList: true,
      articleScopeBranchAll: true,
      articleScopeBranches: null,
      articleScopeWarehouseAll: true,
      articleScopeWarehouses: null,
      articleScopeArticleDefaultSupplier: 'ANY' as const,
      updateScopeSupplierArticleAll: true,
      updateScopeSupplierArticle: [
        'RECOMMENDED_PRICE' as const,
        'PURCHASE_PRICE' as const,
        'SUPPLIER_DISCOUNT_GROUP' as const,
        'BULK_PACKAGE_QUANTITY' as const,
        'ORDERING_NUMBER' as const,
      ],
      updateScopeWarehouseArticleAll: true,
      updateScopeWarehouseArticle: [
        'RECOMMENDED_PRICE' as const,
        'NAME' as const,
        'SUPPLIER_DISCOUNT_GROUP' as const,
      ],
      integrationUpdateListId: null,
      createdAt: '2024-03-28T17:06:02.703Z',
      createdBy: '0b592803-9bef-4840-b0ab-9a2cb6ded726',
      updatedAt: '2024-06-24T15:03:15.667Z',
      updatedBy: '4ce6d202-7684-4939-9d1d-7130c95b9310',
    },
    configuration
  );

const getArticleUpdateJobInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/warehouse/v1/article-update-job/*', () =>
      HttpResponse.json(getArticleUpdateJobMock())
    )
  );

export const metadaWarehouseArticleUpdateJobApiMock = {
  getArticleUpdateJobMock,
  getArticleUpdateJobInterceptor,
};
